<template>
  <div class="dataForm" style="min-width:800px">
    <el-form
    ref="dataForm"
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    label-width="100px"
    class="mb-20"
    >
      <div class="underlineForm">
        <el-form-item label="所属公司" prop="titleId">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.titleId" placeholder="输入关键字搜索" clearable remote :remote-method="getTitleOptionRemote" @focus="getTitleOptionRemote('')" @change="handleCompanyTitleChange">
            <template v-if="titleOption.length">
              <el-option
                v-for="item in titleOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="税率" prop="taxRate">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.taxRate" placeholder="输入关键字搜索" clearable @change="handleCalcTotal(1)">
            <template v-if="taxRateList.length">
              <el-option
                v-for="item in taxRateList"
                :key="item"
                :label="item + '%'"
                :value="item"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户公司名称" prop="customerCompanyId">
          <el-select class="filter-item"
:filterable="true"
v-model="ruleForm.customerCompanyId"
placeholder="输入关键字搜索"
clearable
remote
@change="handleCompanyChange"
@focus="companyRemoteMethod('')"
:remote-method="query => companyRemoteMethod(query)"
          >
            <template v-if="companyOption.length">
              <el-option
                v-for="item in companyOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.disable"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户开票抬头" prop="customerCompanyTicketId" >
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.customerCompanyTicketId" placeholder="输入关键字搜索" clearable>
            <template v-if="customerCompanyTicketOption.length">
              <el-option
                v-for="item in customerCompanyTicketOption"
                :key="item.id"
                :label="item.titleName"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人" prop="customerCompanyContactId">
          <el-select class="filter-item"
:filterable="true"
v-model="ruleForm.customerCompanyContactId"
placeholder="输入关键字搜索"
clearable
remote
@change="handleContactChange"
@focus="groupRemoteMethod('')"
:remote-method="query => groupRemoteMethod(query)"
          >
            <template v-if="companyConyactOption.length">
              <el-option
                v-for="item in companyConyactOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱" prop="receivingEmail">
          <el-input v-model="ruleForm.receivingEmail" type="input" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="收件地址" prop="receivingAddress">
          <el-input v-model="ruleForm.receivingAddress" type="input" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="报价人" prop="salesManId">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.salesManId" placeholder="输入关键字搜索" clearable>
            <template v-if="salesManOption.length">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报价单模版名称" prop="templateName">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.templateName" placeholder="输入关键字搜索" clearable @change="handleTemplateNameChange">
            <template v-if="printTemplateOption.length">
              <el-option
                v-for="item in printTemplateOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="报价单备注模版" prop="quotationMarkTemplateId" v-if="ruleForm.templateName">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.quotationMarkTemplateId" placeholder="输入关键字搜索" clearable @change="handleQuotationMarkTemplateChange">
            <template v-if="quotationMarkTempOption.length">
              <el-option
                v-for="item in quotationMarkTempOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注" prop="mark" class="fullWidth">
          <el-input v-model="ruleForm.mark" type="textarea" class="filter-item quotation-template" clearable ></el-input>
        </el-form-item>
        <div class="mb-20 fullWidth" >
        <el-button @click="handleAddBusinessComand" type="primary" >
          添加业务
        </el-button>
        <el-button @click="removeBusiness" >
          移除业务
        </el-button>
        </div>
        <el-table
          :data="ruleForm.details"
          border
          fit
          row-key="id"
          class="fullWidth"
          :summary-method="getSummaries"
          show-summary
          :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
          @selection-change="handleTableSelect"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column prop="businessNo" label="业务编号" width="150"/>
          <el-table-column prop="businessName" label="业务名称" />
          <el-table-column prop="businessBrand" label="业务品牌" />
          <el-table-column prop="businessModel" label="型号" />
          <el-table-column prop="businessSerial" label="序列号" />
          <el-table-column prop="businessAmount" label="数量" />
          <template v-if="ruleForm.taxRate">
            <el-table-column prop="price" label="单价(含税)" min-width="160">
              <template #default="{ row }">
                <el-input-number v-model="row.price" type="number" @input='handleCalcTotal(1)' :precision="2" controls-position="right"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="priceWithRate" label="单价(未税)" min-width="100" align="right">
              <template #default="{ row }">
                <span>{{ priceWithoutRate(row.price, row.businessAmount, true)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalPrice" label="总价(含税)" min-width="100" align="right">
              <template #default="{ row }">
                <span>{{ numberTimes(row.price, row.businessAmount, true)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalPriceWithRate" label="总价(未税)" min-width="100" align="right">
              <template #default="{ row }">
                <span>{{ totalPriceWithoutRate(row.price, row.businessAmount, true)}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column prop="price" label="单价" min-width="160">
              <template #default="{ row }">
                <el-input-number v-model="row.price" type="number" :precision="2" controls-position="right"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="totalPrice" label="总价(RNB)" min-width="100" align="right">
              <template #default="{ row }">
                <span>{{ numberTimes(row.price, row.businessAmount, true)}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <template v-if="[3, 4].includes(ruleForm.templateName)">
          <h4 class="form-title fullWidth">
            <span class="left">工作描述</span>
          </h4>
          <el-form-item label="故障现象" prop="fault" class="fullWidth">
            <el-input v-model="ruleForm.fault" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="检测情况" prop="checkDes" class="fullWidth">
            <el-input v-model="ruleForm.checkDes" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="更换配件" prop="changeParts" class="fullWidth">
            <el-input v-model="ruleForm.changeParts" type="textarea"></el-input>
          </el-form-item>
        </template>
        <template v-if="[4].includes(ruleForm.templateName)">
          <h4 class="form-title fullWidth">
            <span class="left">配件费</span>
          </h4>
          <div class="fullWidth">
            <el-button @click="handlePartsAdd" type="primary" >添加</el-button>
            <el-button @click="handlePartsDelete">删除</el-button>
            <el-table
              :data="ruleForm.parts"
              border
              fit
              class=" mt-20"
              :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
              @selection-change="handlePartsSelect"
              :summary-method="getSummaries"
              show-summary
            >
              <el-table-column type="selection" width="55" />
              <el-table-column prop="name" label="名称" width="180">
                <template #default="{ row }">
                  <el-autocomplete v-model="row.name" type="text" :fetch-suggestions="(query, cb) => remoteFetchSuggestions(query, cb)" @change="(value) => handlePartsNameChange(value, row)" @select="(value) => handlePartsNameChange(value, row)"/>
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="数量" width="100">
                <template #default="{ row }">
                  <el-input v-model="row.amount" type="number" :min="0" @input="handleCalcTotal(2)"></el-input>
                </template>
              </el-table-column>
              <template v-if="ruleForm.taxRate">
                <el-table-column prop="unitPrice" label="单价(含税)" min-width="160">
                  <template #default="{ row }">
                    <el-input-number v-model="row.unitPrice" type="number" @input="handleCalcTotal(2)" :precision="2" controls-position="right"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column prop="priceWithRate" label="单价(未税)" min-width="100" align="right">
                  <template #default="{ row }">
                    <span>{{ priceWithoutRate(row.unitPrice, row.amount, true)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="totalPrice" label="总价(含税)" min-width="100" align="right">
                  <template #default="{ row }">
                    <span>{{ numberTimes(row.unitPrice, row.amount, true)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="totalPriceWithRate" label="总价(未税)" min-width="100" align="right">
                  <template #default="{ row }">
                    <span>{{ totalPriceWithoutRate(row.unitPrice, row.amount, true)}}</span>
                  </template>
                </el-table-column>
              </template>
              <template v-else>
                <el-table-column prop="unitPrice" label="单价" min-width="160">
                  <template #default="{ row }">
                    <el-input-number v-model="row.unitPrice" type="number" :precision="2" controls-position="right"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column prop="totalPrice" label="总价(RNB)" min-width="100" align="right">
                  <template #default="{ row }">
                    <span>{{ numberTimes(row.unitPrice, row.amount, true)}}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
          <h4 class="form-title fullWidth">
            <span class="left">维修费</span>
          </h4>
          <el-table
            border
            fit
            class="fullWidth mt-20"
            :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
            :data="ruleForm.fee">
            <el-table-column prop="amount" label="数量" min-width="100">
              <template #default="{ row }">
                <el-input v-model="row.amount" type="number" ></el-input>
              </template>
            </el-table-column>
            <template v-if="ruleForm.taxRate">
              <el-table-column prop="unitPrice" label="单价(含税)" min-width="160">
                <template #default="{ row }">
                  <el-input-number v-model="row.unitPrice" type="number" :precision="2" controls-position="right"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="priceWithRate" label="单价(未税)" min-width="100" align="right">
                <template #default="{ row }">
                  <span>{{ priceWithoutRate(row.unitPrice, row.amount, true)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="totalPrice" label="总价(含税)" min-width="100" align="right">
                <template #default="{ row }">
                  <span>{{ numberTimes(row.unitPrice, row.amount, true)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="totalPriceWithRate" label="总价(未税)" min-width="100" align="right">
                <template #default="{ row }">
                  <span>{{ totalPriceWithoutRate(row.unitPrice, row.amount, true)}}</span>
                </template>
              </el-table-column>
            </template>
            <template v-else>
              <el-table-column prop="unitPrice" label="单价" min-width="160">
                <template #default="{ row }">
                  <el-input-number v-model="row.unitPrice" type="number" :precision="2" controls-position="right"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="totalPrice" label="总价(RNB)" min-width="100" align="right">
                <template #default="{ row }">
                  <span>{{ numberTimes(row.unitPrice, row.amount, true)}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </template>
      </div>
    </el-form>
    <div class="dialog-footer mt-20 " >
      <el-button @click="cancle" >
        {{ t("table.cancel") }}
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ t("table.confirm") }}
      </el-button>
      <el-button
        type="primary"
        @click="handlePrint"
      >
        打印
      </el-button>
    </div>
    <el-dialog
      v-if="dialogVisible"
      v-model="dialogVisible"
      title="业务列表"
      width="80%"
    >
      <BusinessTable mode="table" ref="BusinessList" :customerCompanyId="ruleForm.customerCompanyId" pageType="QUOTE" :excludeIds="excludeIds"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false" type="danger">取消</el-button>
          <el-button
            type="primary"
            @click="addBusiness"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-if="printVisible"
      v-model="printVisible"
      title="打印预览"
      width="80%"
    >
      <PrintCom ref="PrintCom" :templateId="ruleForm.templateName" :detail="ruleForm"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="printVisible = false" type="danger">取消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref, watch } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { getPageList } from '@/apis/Form'
import { getCompanyContactById } from '@/apis/CustomerCompanyContact'
import { getTicketTitleDetailById } from '@/apis/TicketTitle'
import { getDetailById } from '@/apis/Dictionary'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate, handleCalcTotal } from '@/utils/index'

import { ElMessage, ElForm } from 'element-plus'
import { createQuotation, updateQuotation } from '@/apis/quotation'
import BusinessTable from '@/views/order/BusinessListDialog.vue'
import PrintCom from './print/Index.vue'

import { useI18n } from 'vue-i18n'
import { debounce } from 'lodash'
import { printTemplateList } from '@/utils/print'
import $number from 'number-precision'
import $currency from 'currency.js'

export default defineComponent({
  components: {
    BusinessTable,
    PrintCom
  },
  props: {
    id: { type: Number, required: false, default: 0 },
    dialogFormVisible: { type: Boolean, required: true },
    api: { type: String, required: true },
    handleResolveTempData: { type: Function, required: false },
    selectionBusiness: { type: Array, required: false, default: () => [] },
    from: { type: String, required: false, default: 'quotation' },
    selectcCustomerCompanyId: { required: false, default: '' }
  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref(ElForm)
    const BusinessList = ref({})

    const dataMap = reactive({
      from: props.from,
      submitLoading: false,
      ruleForm: {
        titleId: '',
        taxRate: 0,
        salesManId: '',
        customerCompanyId: '',
        customerCompanyContactId: '',
        receivingEmail: '',
        receivingAddress: '',
        fault: '',
        checkDes: '',
        changeParts: '',
        mark: '',
        templateName: 2,
        customerCompanyTicketId: '',
        quotationMarkTemplateId: '',
        details: [],
        parts: [{
          id: Date.now(),
          name: '',
          amount: '',
          unitPrice: '',
          totalPrice: '',
          totalPriceWithRate: ''
        }],
        fee: [{
          amount: '',
          unitPrice: '',
          totalPrice: '',
          totalPriceWithRate: ''
        }]
      },
      rules: {
        titleId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        taxRate: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        salesManId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        customerCompanyId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        customerCompanyContactId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        receivingEmail: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        receivingAddress: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        fault: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        checkDes: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        changeParts: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        mark: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        templateName: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        customerCompanyTicketId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        quotationMarkTemplateId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        details: []
      },
      titleOption: [],
      companyConyactOption: [],
      salesManOption: [],
      companyOption: [],
      dialogVisible: false,
      selectBusinessList: [],
      taxRateList: [],
      excludeIds: [],
      printTemplateOption: printTemplateList,
      quotationMarkTempOption: [],
      customerCompanyTicketOption: [],
      printVisible: false,
      partsSelection: [],
      partsNameOption: [],

      handleContactChange(value: any) {
        if (value) {
          const temp = dataMap.companyConyactOption.find((kk: any) => kk.id === value) || {}
          dataMap.ruleForm.receivingEmail = temp.email
          getCompanyContactById(value).then((res: any) => {
            dataMap.ruleForm.receivingAddress = res.address + res.addressDetail
          })
        } else {
          dataMap.ruleForm.receivingEmail = ''
          dataMap.ruleForm.receivingAddress = ''
        }
      },
      handleCompanyTitleChange(value: any) {
        // dataMap.ruleForm.taxRate = ''
        dataMap.taxRateList = []
        if (value) {
          getTicketTitleDetailById(value).then((res: any) => {
            dataMap.taxRateList = res.taxRate
            dataMap.ruleForm.taxRate = dataMap.taxRateList[0] as any
            dataMap.handleCalcTotal(1)
          })
        }
      },
      handleQuotationMarkTemplateChange(value: any) {
        const tempData = dataMap.quotationMarkTempOption.find(k => k.id === value) || {}
        dataMap.ruleForm.mark = tempData.mark
      },
      handleTableSelect(selection: any) {
        dataMap.selectBusinessList = selection
      },
      async handleCompanyChange(value: number) {
        dataMap.ruleForm.customerCompanyContactId = ''
        dataMap.companyConyactOption = []
        dataMap.ruleForm.receivingEmail = ''
        dataMap.ruleForm.receivingAddress = ''
        dataMap.ruleForm.salesManId = ''
        dataMap.ruleForm.customerCompanyTicketId = ''
        if (value) {
          const tempData = await getDetailById('customerCompany', value)
          dataMap.ruleForm.salesManId = tempData.salesManId
          dataMap.ruleForm.receivingAddress = tempData.address + tempData.addressDetail
          dataMap.groupRemoteMethod('', true)
          dataMap.loadCustomerCompanyTicketTitle(true)
        }
      },
      handleTemplateNameChange(value: number) {
        if (value) {
          dataMap.rules.quotationMarkTemplateId[0].required = true
        } else {
          dataMap.ruleForm.quotationMarkTemplateId = ''
          dataMap.ruleForm.fault = ''
          dataMap.ruleForm.checkDes = ''
          dataMap.ruleForm.changeParts = ''
        }
        if ([2, 3, 4].includes(Number(dataMap.ruleForm.templateName))) {
          dataMap.ruleForm.quotationMarkTemplateId = ''
        }
      },
      getTitleOptionRemote: debounce((query: string | number, defaultVal?: boolean) => {
        getPageList(`ticketTitle/dropdown?name=${query}`).then((res: any) => {
          dataMap.titleOption = res || []
          if (defaultVal) {
            dataMap.ruleForm.titleId = dataMap.titleOption.length ? dataMap.titleOption[0].id : ''
            dataMap.handleCompanyTitleChange(dataMap.ruleForm.titleId)
          }
        })
      }, 500),
      companyRemoteMethod: debounce((query: string | number) => {
        getPageList('customerCompany/dropdown', { name: query, ids: props.selectcCustomerCompanyId }).then((res: any) => {
          dataMap.companyOption = res
            ? res.map((k: any) => {
              if (!k.salesManId) {
                k.disable = true
              } else {
                k.disable = false
              }
              return k
            })
            : []
        })
      }, 500),
      groupRemoteMethod: debounce((query: string | number, bool?: boolean) => {
        if (!dataMap.ruleForm.customerCompanyId) {
          return
        }
        const params = { name: query, companyId: dataMap.ruleForm.customerCompanyId }
        getPageList('customerCompanyContact/dropdown', params).then((res: any) => {
          dataMap.companyConyactOption = res || []
          if (bool) {
            dataMap.ruleForm.customerCompanyContactId = dataMap.companyConyactOption[0].id
            dataMap.ruleForm.receivingEmail = dataMap.companyConyactOption[0].email
          }
        })
      }, 500),
      handleAddBusinessComand() {
        if (!dataMap.ruleForm.customerCompanyId) {
          return ElMessage.error('请先选择客户公司名称！')
        }
        if ([2, 3, 4].includes(dataMap.ruleForm.templateName) && dataMap.ruleForm.details.length >= 1) {
          return ElMessage.error('该模版只能选择一个业务！')
        }
        dataMap.dialogVisible = true
      },
      getexcludeIds() {
        dataMap.excludeIds = dataMap.ruleForm.details.map((k: any) => {
          return k.businessId
        })
        return dataMap.excludeIds
      },
      addBusiness(array: any) {
        let tempArray = array && array.length ? array : (BusinessList.value as any).selectionArray
        console.log(tempArray, 'tempArray')
        tempArray = dataMap.ruleForm.details.concat(tempArray)
        if ([2, 3, 4].includes(Number(dataMap.ruleForm.templateName)) && tempArray.length > 1) {
          return ElMessage.error('该模版只能选择一个业务！')
        }

        for (let i = 0; i < tempArray.length; i++) {
          const item = tempArray[i]
          if (item.repairType === '预检' && ['自己维修', '现场维修'].includes(item.type)) {
            const { fault, changeParts, checkDes } = item
            if (!fault || !changeParts || !checkDes) {
              return ElMessage.error({
                message: '预检且为自己维修或现场维修业务，故障现象、更换配件、检测情况字段不得为空！',
                duration: 4000
              })
            }
          }
        }

        dataMap.ruleForm.details = (tempArray || []).map((item: any) => {
          return {
            businessId: item.businessId || item.id,
            businessNo: item.businessNo || item.no,
            businessName: item.businessName || item.name,
            businessBrand: item.businessBrand || item.brand,
            businessModel: item.businessModel || item.model,
            businessSerial: item.businessSerial || item.serial,
            businessAmount: item.businessAmount || item.amount,
            price: item.price || 0,
            amount: item.amount || 0,
            businessUnit: item.businessUnit || item.unit
          }
        })
        dataMap.dialogVisible = false
      },
      getBusinessDetail(businessId: number) {
        getDetailById('business', businessId).then((res: any) => {
          dataMap.ruleForm.fault = res.fault
          if ([3, 4].includes(dataMap.ruleForm.templateName)) {
            dataMap.ruleForm.checkDes = res.checkDes
            dataMap.ruleForm.changeParts = res.changeParts
          }
        })
      },
      removeBusiness() {
        if (!dataMap.selectBusinessList.length) {
          return ElMessage.error('请选择需要移除的业务！')
        }
        dataMap.ruleForm.details = dataMap.ruleForm.details.filter((k: any) => {
          return !dataMap.selectBusinessList.find(j => j.businessId === k.businessId)
        })
        // if (!dataMap.ruleForm.details.length) {
        //   dataMap.ruleForm.fault = ''
        //   dataMap.ruleForm.checkDes = ''
        //   dataMap.ruleForm.changeParts = ''
        // }
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const { fee, details, parts, templateName } = dataMap.ruleForm
              for (let i = 0; i < details.length; i++) {
                const item = details[i]
                if (item.price === 0) {
                  return ElMessage.error({
                    message: `是否确定${item.businessName}业务报价为0元？`,
                    duration: 3000
                  })
                }
              }
              if (templateName === 4) {
                for (let i = 0; i < parts.length; i++) {
                  const item = parts[i]
                  if (!item.name || (!item.amount && Number(item.amount) !== 0) || (!item.unitPrice && Number(item.unitPrice) !== 0)) {
                    return ElMessage.error({
                      message: '请填写配件费必填项！',
                      duration: 3000
                    })
                  }
                }
                for (let i = 0; i < fee.length; i++) {
                  const item = fee[i]
                  if ((!item.amount && Number(item.amount) !== 0) || (!item.unitPrice && Number(item.unitPrice) !== 0)) {
                    return ElMessage.error({
                      message: '请填写维修费必填项！',
                      duration: 3000
                    })
                  }
                }
              }

              const tempData = {
                ...dataMap.ruleForm,
                fee: fee && fee.length ? fee[0] : null
              }
              const formSate = !props.id ? 'add' : 'edit'
              if (formSate === 'add') {
                await createQuotation(tempData)
              } else {
                await updateQuotation(props.id, tempData)
              }
              dataMap.submitLoading = false
              context.emit('update:visibel')
              context.emit('submit')
              ElMessage({
                message: !props.id ? '创建成功' : '编辑成功',
                type: 'success',
                duration: 2000
              })
            } catch (err:any) {
              console.log(err, 'err')
              dataMap.submitLoading = false
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      },
      handlePrint() {
        if (!dataMap.ruleForm.templateName) {
          return ElMessage.error('请选择报价单模版名！')
        }
        dataMap.printVisible = true
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      },
      loadOption() {
        getPageList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
        getPageList('quotationMarkTemplate/page?size=9999').then((res: any) => {
          dataMap.quotationMarkTempOption = res.data || []
        })
      },

      loadCustomerCompanyTicketTitle(setDefalut?: boolean) {
        if (!dataMap.ruleForm.customerCompanyId) {
          return
        }
        getPageList(`customerCompanyTicketTitle/page?size=999&customerCompanyId=${dataMap.ruleForm.customerCompanyId}`).then((res: any) => {
          dataMap.customerCompanyTicketOption = res.data || []
          if (setDefalut) {
            dataMap.ruleForm.customerCompanyTicketId = dataMap.customerCompanyTicketOption[0] ? dataMap.customerCompanyTicketOption[0].id : ''
          }
        })
      },
      async handlePartsAdd() {
        const record = {
          id: Date.now(),
          name: '',
          amount: '',
          unitPrice: '',
          totalPrice: '',
          totalPriceWithRate: ''
        }

        dataMap.ruleForm.parts.push(record)
      },
      handlePartsDelete() {
        if (!dataMap.partsSelection.length) {
          return ElMessage.error('请选择需要移除的数据！')
        }
        dataMap.partsSelection.forEach((item: any) => {
          dataMap.ruleForm.parts = dataMap.ruleForm.parts.filter((k: any) => item.id !== k.id)
        })
      },
      // ccountAmount(row: any) {
      //   const amount = row.amount ? row.amount * 1 : 0
      //   const unitPrice = row.unitPrice ? row.unitPrice * 1 : 0
      //   return $currency($number.times(amount, unitPrice))
      // },

      handlePartsSelect(selection: any) {
        dataMap.partsSelection = selection
      },
      remoteFetchSuggestions: debounce((query: string, cb: any) => {
        getPageList(`quotation/actions/quotationFeeHistory?name=${query}`).then((res: any) => {
          const newOption = !res
            ? []
            : res.map((item: any) => {
              return {
                value: item.name,
                priceList: item.priceList || []
              }
            })
          dataMap.partsNameOption = newOption
          cb(newOption)
        })
      }, 500),
      handlePartsNameChange(val: any, row: any) {
        if (val instanceof Object) {
          const { priceList } = val
          row.unitPrice = priceList[0]
        }
      },
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),
      priceWithoutRate: (price: any, amount: any, isCurrency: boolean) => priceWithoutRate(price, isCurrency, dataMap.ruleForm.taxRate),
      totalPriceWithoutRate: (price: any, amount: any, isCurrency: boolean) => totalPriceWithoutRate(price, amount, isCurrency, dataMap.ruleForm.taxRate),
      handleCalcTotal: (index: number) => {
        if (index === 1) {
          dataMap.ruleForm.details = handleCalcTotal(dataMap.ruleForm.details, dataMap.ruleForm.taxRate, 'price', 'businessAmount')
        } else {
          dataMap.ruleForm.parts = handleCalcTotal(dataMap.ruleForm.parts, dataMap.ruleForm.taxRate, 'unitPrice', 'amount')
        }
      },
      getSummaries(param: any) {
        const { columns, data } = param
        const sums: string[] = []
        columns.forEach((column: any, index: number) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          const values = data.map((item: any) => Number(item[column.property]))
          if (['amount', 'totalPrice', 'totalPriceWithRate'].includes(column.property) && !values.every((value: any) => Number.isNaN(value))) {
            const sumNum = `${values.reduce((prev: any, curr: any) => {
              const value = Number(curr)
              if (!Number.isNaN(value)) {
                return $number.plus(prev, curr)
              }
              return prev
            }, 0)}`
            sums[index] = ['totalPrice', 'totalPriceWithRate'].includes(column.property) ? $currency(sumNum).toString() : sumNum.toString()
          } else {
            sums[index] = ''
          }
        })
        return sums
      }
    })

    watch(() => dataMap.ruleForm.details, () => {
      if (dataMap.ruleForm.details.length === 1) {
        const businessId = dataMap.ruleForm.details[0].businessId
        dataMap.getBusinessDetail(businessId)
        dataMap.rules.fault[0].required = true
        dataMap.rules.checkDes[0].required = true
        dataMap.rules.changeParts[0].required = true
      } else {
        dataMap.ruleForm.fault = ''
        dataMap.ruleForm.checkDes = ''
        dataMap.ruleForm.changeParts = ''
        dataMap.rules.fault[0].required = false
        dataMap.rules.checkDes[0].required = false
        dataMap.rules.changeParts[0].required = false
      }
      dataMap.getexcludeIds()
    })
    onMounted(() => {
      if (props.id) {
        getDetailById(props.api, props.id).then((res: any) => {
          const { fee } = res
          dataMap.ruleForm = { ...res, fee: fee ? [fee] : [] }
          ;(dataMap.ruleForm.templateName as any) = Number(dataMap.ruleForm.templateName)
          dataMap.handleCompanyTitleChange(res.titleId)
          dataMap.ruleForm.details = res.details
            ? res.details.map((k: any) => {
              return {
                ...k,
                id: k.businessId,
                businessAmount: k.amount,
                totalPrice: dataMap.numberTimes(k.price, k.amount, true),
                totalPriceWithRate: dataMap.totalPriceWithoutRate(k.price, k.amount, true)
              }
            })
            : []
          dataMap.ruleForm.parts = dataMap.ruleForm.parts.map((item: any) => {
            return {
              ...item,
              totalPriceWithRate: dataMap.totalPriceWithoutRate(item.unitPrice, item.amount, true)
            }
          })
          getTicketTitleDetailById(dataMap.ruleForm.titleId).then((res: any) => {
            dataMap.taxRateList = res.taxRate
          })
          dataMap.loadCustomerCompanyTicketTitle()
        })
        dataMap.getTitleOptionRemote('')
        dataMap.companyRemoteMethod('')
        dataMap.groupRemoteMethod('')
      } else {
        dataMap.getTitleOptionRemote('', true)
        ;(dataMap.ruleForm.templateName as any) = 2
        dataMap.handleTemplateNameChange(2)
      }
      if (props.selectionBusiness.length) {
        if (props.selectionBusiness.length > 1) {
          dataMap.ruleForm.templateName = 1
        }
        dataMap.companyRemoteMethod('')
        dataMap.addBusiness(props.selectionBusiness)
        dataMap.ruleForm.customerCompanyId = props.selectcCustomerCompanyId
        dataMap.handleCompanyChange(dataMap.ruleForm.customerCompanyId as any)
      }
      dataMap.loadOption()
      dataMap.clearValidate()
    })
    return { t, ...toRefs(dataMap), dataForm, BusinessList }
  }
})
</script>
